import MetaFootballModel from "./MetaFootballModel";

export default class FootballPaginationModel {
    public meta: MetaFootballModel = new MetaFootballModel();
    public data: any[] = [];
}